module.exports = {};


//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/$.iterators.js
// module id = 52
// module chunks = 0